import { render, staticRenderFns } from "./VCRData.vue?vue&type=template&id=37e0eb8b&scoped=true&"
import script from "./VCRData.vue?vue&type=script&lang=ts&"
export * from "./VCRData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0eb8b",
  null
  
)

export default component.exports